export function isTwaDomain(): boolean {
  const hostname: string = window.location.hostname;
  const splitedHostname: string[] = hostname.split('.');

  if (splitedHostname.length === 3) {
    return splitedHostname[0] === 'tg';
  }

  return hostname.includes('tg.com');
}
